// src/screens/LoanDrilldownScreen/tabs/LoanDrilldownFilesTab/LoanFilesTable/LoanFilesTable.jsx
import { ModuleRegistry } from "ag-grid-community";
import {
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MultiFilterModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
  TreeDataModule,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useRef } from "react";

import isEmpty from "lodash/isEmpty";

import { useColumnDefs } from "./hooks/useColumnDefs";
import { useGetRowId } from "./hooks/useGetRowId";
import { columnTypesDate } from "../../../_src_shared/utils/agGrid/columnTypes/columnTypesDate";
import { columnTypesNumber } from "../../../_src_shared/utils/agGrid/columnTypes/columnTypesNumber";
import { columnTypesDollar } from "../../../_src_shared/utils/agGrid/columnTypes/columnTypesDollar";
import { useSidebar } from "../../../_src_shared/utils/agGrid/hooks/useSidebar";
import Flx from "../../../components/layout/Flx";
import AgGridTableWrapper from "../../../components/agGrid/AgGridTableWrapper";

ModuleRegistry.registerModules([
  SideBarModule,
  RowGroupingPanelModule,
  MultiFilterModule,
  RowGroupingModule,
  PivotModule,
  TreeDataModule,
  FiltersToolPanelModule,
  ColumnsToolPanelModule,
  SetFilterModule,
]);

const LoanSizerFilesTable = ({
  rowData,
  autoHeight,
  quickFilter,
  height = "100%",
}) => {
  const gridRef = useRef(null);

  //
  // Capture the “original” snapshot once so diffs work correctly
  //

  // Column definitions & types
  const columnDefs = useColumnDefs();

  const columnTypes = useMemo(() => {
    return {
      ...columnTypesDate(),
      ...columnTypesNumber(),
      ...columnTypesDollar(),
    };
  }, []);
  const getRowId = useGetRowId();
  const sidebar = useSidebar();

  // Row ID extractor

  // Auto‐group column definition
  // const autoGroupColumnDef = useAutoGroupColumnDef();

  // const getRowStyle = useGetRowStyles();

  if (isEmpty(rowData)) {
    return null;
  }

  return (
    <AgGridTableWrapper height={height} simpleTable size={4}>
      <AgGridReact
        ref={gridRef}
        // getRowId={getRowId}
        rowData={rowData}
        columnDefs={columnDefs}
        columnTypes={columnTypes}
        singleClickEdit
        sideBar={sidebar}
        quickFilterText={quickFilter}
        // groupDisplayType={"groupRows"}
        domLayout={autoHeight ? "autoHeight" : "normal"}
      />
    </AgGridTableWrapper>
  );

  return (
    <Flx flexGrow={1} column gap={0} sx={{ overflowY: "auto" }}>
      <Flx
        column
        sx={{
          overflow: "hidden",
          flexGrow: 1,
          gap: 2,
        }}
      >
        <AgGridTableWrapper height={height} simpleTable size={4}>
          <AgGridReact
            ref={gridRef}
            getRowId={getRowId}
            rowData={rowData}
            columnDefs={columnDefs}
            columnTypes={columnTypes}
            singleClickEdit
            sideBar={sidebar}
            quickFilterText={quickFilter}
            groupDisplayType={"groupRows"}
            domLayout={"autoHeight"}
          />
        </AgGridTableWrapper>
      </Flx>
    </Flx>
  );
};

export default LoanSizerFilesTable;
